const backgroundRepeat = {
    name: "background-repeat",
    path: "/background-repeat",
    title: "background-repeat",
    description: "Utilities for controlling an element's background repeat behavior.",
    value: {
        "background-repeat": {
            "bg-repeat": "repeat",
            "bg-no-repeat": "no-repeat",
            "bg-repeat-x": "repeat-x",
            "bg-repeat-y": "repeat-y",
            "bg-repeat-round": "round",
            "bg-repeat-space": "space",
        }
    },
    exampleData: [
        {
            example: {
                code: `
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-repeat bg-size-16 h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-no-repeat bg-size-16 h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-repeat-x bg-size-16 h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-repeat-y bg-size-16 h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-repeat-round bg-size-16 h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-repeat-space bg-size-16 h-32"></div>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-repeat</code>, <code>bg-no-repeat</code>, <code>bg-repeat-x</code>, <code>bg-repeat-y</code>, <code>bg-repeat-round</code>, and <code>bg-repeat-space</code> utilities to control the background repeat behavior of an element.
      </p>
      <div class="mx-auto grid grid-columns-2 gap-4">
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-repeat</p>
          <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-repeat bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-no-repeat</p>
          <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-no-repeat bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-repeat-x</p>
            <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-repeat-x bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-repeat-y</p>
        <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-repeat-y bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-repeat-round</p>
        <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-repeat-round bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
        <div>
          <p class="mb-2 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-repeat-space</p>
        <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-repeat-space bg-size-[3rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
        </div>
      </div>
      `
        }
    ]
};

export default backgroundRepeat;
<div className="sr-only">
    <div class="bg-image-[url(https://img.freepik.com/free-vector/abstract-organic-pattern-design-background_1048-19286.jpg)] bg-size-[3rem] bg-repeat bg-no-repeat bg-repeat-x  bg-repeat-y  bg-repeat-round bg-repeat-space bg-size-[8rem] h-24 rounded-lg border-3 border-color-gray-400 border-style-dashed"></div>
</div>